module.exports = __webpack_public_path__ + "static/media/excel.0f2a8706.svg";